import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import PropTypes from "prop-types"
import DataTableAvisEtudiant from "./DataTableAvisEtudiant"
const AvisEtudiant = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);

    useEffect(async () => {
      const loadData = async () => {
        try {
          const cloture_annee = JSON.parse(localStorage.getItem("cloture"))
          setCloture(cloture_annee)
          const userAuth = JSON.parse(localStorage.getItem("UserMenu")) || []
          const typeArticleSubMenu = userAuth.find(
            user =>
              Array.isArray(user.sous_menu) &&
              user.sous_menu.some(
                subMenu => subMenu.sous_menu === "Avis pour les étudiants"
              )
          )
          if (typeArticleSubMenu) {
            const menu = typeArticleSubMenu.sous_menu.find(
              subMenu => subMenu.sous_menu === "Avis pour les étudiants"
            )
            if (menu) {
              setAdd(menu.add)
            }
          } else {
            console.warn(
              "Le sous-menu 'Avis pour les étudiants' est introuvable."
            )
          }
        } catch (error) {
          console.error(error)
        }
      }

      loadData()

    }, [])
    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableAvisEtudiant setSection={setSection} back={back} />
        }
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{props.t("Avis Etudiant")} | Cresus </title>
          </MetaTags>
          <Container fluid>
            <div>
              <Nav tabs>
                {cloture !== 1 ? (
                  add === 1 ? (
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: section === 1,
                        })}
                        onClick={() => {
                          setSection(1)
                        }}
                      >
                        {props.t("Avis Etudiant")}
                      </NavLink>
                    </NavItem>
                  ) : null
                ) : null}
              </Nav>
              <Card>
                <CardBody>{renderBlock(section)}</CardBody>
              </Card>
            </div>
          </Container>
        </div>
      </React.Fragment>
    )
}

export default withRouter(withTranslation()(AvisEtudiant))
AvisEtudiant.propTypes = {
    t: PropTypes.any,
}
